import {
    type DashboardOverviewResponseType
} from "./type";
import {
    request
} from "../request";

const getDashboardOverview = async (): Promise<DashboardOverviewResponseType> => {
    return await request<DashboardOverviewResponseType>("/dashboard/overview", {
        method: "GET"
    });
};
export default getDashboardOverview;
